import { useAtomValue } from 'jotai';
import pick from 'lodash/pick';
import { useMemo } from 'react';
import { activeTabIdAtom, panelStateAtom } from '../atoms/session-atoms';
import { VERSION_FINGERPRINT } from '../bi/constants';
import { BiScreenTypes } from '../bi/types';
import { ACCESSIBILITY_WIZARD_TAB_IDS } from '../consts';
import { useA11yWizardAdapter } from './use-a11y-wizard-adapter';
import { useSessionInfoContext } from './use-session-info-context';
export const useBiCommon = () => {
  const {
    editorHost
  } = useA11yWizardAdapter();
  const {
    lastScanTimeStamp
  } = useAtomValue(panelStateAtom);
  const relevantTimestamp = lastScanTimeStamp;
  const activeTabId = useAtomValue(activeTabIdAtom);
  const sessionInfo = useSessionInfoContext();
  const commonParams = useMemo(() => ({
    editor_type: editorHost,
    site_scan_timestamp: relevantTimestamp,
    version_display: VERSION_FINGERPRINT,
    ...pick(sessionInfo, ['esi', 'locale', 'msid', 'referral', 'wizard_session_start_ts', 'lastScanTimestamp'])
  }), [editorHost, relevantTimestamp, sessionInfo]);
  const screenType = useMemo(() => {
    return relevantTimestamp === undefined ? BiScreenTypes.WelcomeScreen : activeTabId === ACCESSIBILITY_WIZARD_TAB_IDS.DETECTED_TASKS ? BiScreenTypes.DetectedIssues : BiScreenTypes.ManualTasks;
  }, [activeTabId, relevantTimestamp]);
  return {
    commonParams,
    screenType
  };
};
//# sourceMappingURL=use-bi-common.js.map